var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex xs-12 p4"},[_c('beneficiaries',{staticClass:"mt4 xs-12",attrs:{"caseId":_vm.caseId,"insuredId":_vm.insuredId,"list":_vm.computedBeneficiaries},on:{"added":_vm.fetchCase,"removed":_vm.fetchCase}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }